import React from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import Button from "components/Button";

const Page = styled.div`
  margin: 20vh auto 0 auto;
  padding: 0 8px;
  max-width: 1024px;
  height: 70vh;
`;

const Heading = styled.h2`
  font-family: ${props => props.theme.fonts.subheading};
  margin-bottom: 4px;
  text-transform: none;
`;

const Text = styled.div`
  font-size: 1.1em;
`;

const Message = styled.div`
  margin-bottom: 32px;
`;

export default function ErrorPage({ clearError }) {
  return (
    <Page>
      <Message>
        <Heading>Uh-oh, an error occured</Heading>
        <Text>
          The error has been reported and we'll fix it as soon as possible.
        </Text>
      </Message>
      <Link onClick={clearError} to="/">
        <Button>Back To Landing Page</Button>
      </Link>
    </Page>
  );
}
